import React from 'react';
import {CATALOG_ROUTE, PICTURES_PATH} from "../utils/consts";
import {useDispatch} from "react-redux";
import styles from '../css/style.css';
import {NavLink} from "react-router-dom";

const MainProductCard = ({pair}) => {
    const dispatch = useDispatch();
    const showModal = (product) => {
        dispatch({type: 'SHOW_MODAL'})
        dispatch({type: 'ADD_DATA_TO_MODAL', payload: {
                id: product.id,
                title: product.title,
                price: product.price,
                description: product.description,
                img: product.img,
                species: product.species,
                sort: product.sort,
                size: product.size
            }})
    }
    return (
        <div>
            {pair.map((product, index) => (
                <div key={index}>
                    <article className="single_product">
                        <figure>
                            <div className="product_thumb">
                                <NavLink className="primary_img" to={`${CATALOG_ROUTE}/${product.id}`}>
                                    <img src={`${PICTURES_PATH}product/${product.img.split(';')[0]}`} alt={product.title} />
                                </NavLink>
                                <div className="action_links">
                                    <ul>
                                        <li className="quick_button">
                                            <a href="#"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   showModal(product);
                                               }}
                                               data-toggle="modal"
                                               data-target="#modal_box"
                                               title="Подробнее">
                                                <i className="icon-eye"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <figcaption className="product_content">
                                <NavLink to={`${CATALOG_ROUTE}/${product.id}`}>
                                    <h4 className="product_name">{product.title}</h4>
                                    <div className="product_sort">{product.sort}</div>
                                    <div className="product_size">{product.size}</div>
                                </NavLink>
                                <div className="price_box">
                                    <span className="current_price">{product.price}</span>
                                </div>
                            </figcaption>
                        </figure>
                    </article>
                </div>
            ))}
        </div>
    );
};

export default MainProductCard;